import { Pencil } from 'lucide-react';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseContainer from '../../../components/containers/BaseContainer';
import Bar from '../../../components/elements/Bar';
import {
  deleteAlternativeClassificationsItem,
  patchAlternativeClassifications,
  postAlternativeClassifications,
} from '@/store/actions/classification';
import ClassificationDetailList from './components/ClassificationDetailList';
import AlternativeClassificationModal from './components/modals/AlternativeClassificationModal';
import ClassificationDetailModal from './components/modals/ClassificationDetailModal';
import TwoColumnEditableList from './components/TwoColumnEditableList';

function ClassificationDetailView() {
  const [visibleDetailModal, setVisibleDetailModal] = useState(false);
  const [visibleAlternativeClassificationModal, setVisibleAlternativeClassificationModal] =
    useState(false);
  const [editAlternativeClassificationId, setEditAlternativeClassificationId] = useState(null);
  const { detail, active_classification } = useSelector((state) => (state as any).classification);
  const permission = useSelector((state) => state.auth.pagePermission);
  const dispatch = useDispatch();

  if (!detail) {
    return null;
  }

  const submitAlternativeClassification = async (values) => {
    try {
      if (editAlternativeClassificationId) {
        const { data } = await patchAlternativeClassifications(
          editAlternativeClassificationId,
          values
        );
        if (data) {
          setVisibleAlternativeClassificationModal(false);
          setEditAlternativeClassificationId(null);
          dispatch({
            type: 'EDIT_ALTERNATIVE_CLASSIFICATION_SUCCESS',
            data,
          });
        }
      } else {
        const { data } = await postAlternativeClassifications(values, active_classification);

        if (data) {
          setVisibleAlternativeClassificationModal(false);
          dispatch({
            type: 'ADD_ALTERNATIVE_CLASSIFICATION_SUCCESS',
            data,
          });
        }
      }
    } catch {
      //
    }
  };

  const removeItemAlternativeClassification = async (id) => {
    try {
      const { status } = await deleteAlternativeClassificationsItem(id);
      if (status === 204) {
        dispatch({
          type: 'REMOVE_ALTERNATIVE_CLASSIFICATION_SUCCESS',
          data: id,
        });
      }
    } catch {
      //
    }
  };

  const editAlternativeClassification = async (id) => {
    setVisibleAlternativeClassificationModal(true);
    setEditAlternativeClassificationId(id);
  };

  const findCurrentAlterantiveClass = () => {
    const result = (detail?.alternative_classification_set || []).find(
      (ele) => ele.id === editAlternativeClassificationId
    );
    if (result) {
      return result;
    }
    return null;
  };

  const onCloseAlternativeClass = () => {
    setVisibleAlternativeClassificationModal(false);
    setEditAlternativeClassificationId(null);
  };

  return (
    <div>
      <BaseContainer fullHeight width={'calc(100% - 420px)' as any} margin>
        <Bar
          text="Detail"
          content={
            permission === 2
              ? [
                  <Pencil
                    key={1}
                    className="h-4 w-4"
                    onClick={() => setVisibleDetailModal(true)}
                    data-testid="classification-detail-edit-btn"
                  />,
                ]
              : []
          }
        />
        <ClassificationDetailList />
        {detail && (
          <TwoColumnEditableList
            addItem={() => setVisibleAlternativeClassificationModal(true)}
            removeItem={(id) => {
              removeItemAlternativeClassification(id);
            }}
            editItem={(id) => {
              editAlternativeClassification(id);
            }}
          />
        )}
      </BaseContainer>
      <ClassificationDetailModal
        visible={visibleDetailModal}
        onClose={() => setVisibleDetailModal(false)}
      />
      <AlternativeClassificationModal
        submitForm={submitAlternativeClassification}
        visible={visibleAlternativeClassificationModal}
        formProps={findCurrentAlterantiveClass()}
        onClose={() => onCloseAlternativeClass()}
      />
    </div>
  );
}

export default ClassificationDetailView;
